var map = {
	"./arduino-1.png": 1514,
	"./arduino-2.png": 307,
	"./arduino-3.png": 7797,
	"./arduino-4.png": 6721,
	"./arduino-5.png": 829,
	"./checker.png": 1447,
	"./choose.png": 4846,
	"./computer.png": 4640,
	"./craftzone-cover.png": 7340,
	"./craftzone.png": 184,
	"./creative.png": 9858,
	"./creative1.png": 1955,
	"./digital.png": 9092,
	"./eketnse-cover.jpg": 8790,
	"./kompletecare-cover.png": 4070,
	"./learn.png": 3610,
	"./news.png": 1841,
	"./offer.png": 1271,
	"./partner.png": 3218,
	"./people.png": 2867,
	"./review.png": 9978,
	"./talent.png": 570,
	"./type.png": 4162,
	"./workspace.png": 5392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;